/**
 * Product types con schema dbmng per i campi extra.
 * Lo schema dbmng è pronto per essere gestito lato server in futuro.
 */
export const PRODUCT_TYPES = [
  {
    id_product_type: "ferti",
    name: "Fertilizzanti",
    id_crop_operation: 3,
    dbmng: [
      {
        field: "n",
        label: "N %",
        type: "float",
        widget: "numeric",
        col: "col-4",
        default: 0
      },
      { field: "p", label: "P %", type: "float", widget: "numeric", col: "col-4", default: 0 },
      { field: "k", label: "K %", type: "float", widget: "numeric", col: "col-4", default: 0 },
    ],
  },
  {
    id_product_type: "pesti",
    name: "Fitofarmaci",
    id_crop_operation: 10,
    dbmng: {},
  },
  {
    id_product_type: "seed",
    name: "Sementi",
    id_crop_operation: 9,
    dbmng: {},
  },
  {
    id_product_type: "feed",
    name: "Alimenti animali",
    dbmng: {
      ss: {
        label: "SS - Sostanza secca (%)",
        type: "float",
        widget: "numeric",
      },
      fg: {
        label: "FG - Fibra grezza (% t.q.)",
        type: "float",
        widget: "numeric",
      },
      pg: {
        label: "PG - Proteina grezza (% t.q.)",
        type: "float",
        widget: "numeric",
      },
      ee: {
        label: "EE - Estratto etereo (% t.q.)",
        type: "float",
        widget: "numeric",
      },
    },
  },
  {
    id_product_type: "rations",
    name: "Razioni",
    hasRecipe: true,
    dbmng: {},
  },
  {
    id_product_type: "other",
    name: "Altri",
    dbmng: {},
  },
];

/**
 * Moltiplicatore per conversione unità di misura in kg
 */
export const UOM_MULTIPLIER = {
  kg: 1, q: 100, t: 1000, g: 0.001, l: 1, ml: 0.001, n: 1
}

export const UOM_OPTIONS = [
  { value: 'kg', label: 'kg' },
  { value: 'q',  label: 'q'  },
  { value: 't',  label: 't'  },
  { value: 'g',  label: 'g'  },
  { value: 'l',  label: 'l'  },
  { value: 'ml', label: 'ml' },
  { value: 'n',  label: 'n°' },
]

export function getProductType(id) {
  return PRODUCT_TYPES.find(t => t.id_product_type === id)
}

export function getProductTypeName(id) {
  return getProductType(id)?.name || id
}

/**
 * Normalizza dbmng da array a oggetto.
 * Se dbmng è un array (es. fertilizzanti), converte usando 'field' come chiave.
 * Se è già un oggetto, lo restituisce così com'è.
 */
export function normalizeDbmng(dbmng) {
  if (!dbmng) return {}
  
  // Se è già un oggetto, restituiscilo così com'è
  if (!Array.isArray(dbmng)) return dbmng
  
  // Se è un array, converti in oggetto usando 'field' come chiave
  const obj = {}
  for (const item of dbmng) {
    if (item.field) {
      obj[item.field] = item
    }
  }
  return obj
}

/**
 * Trova il product_type associato a un crop_operation.
 * Es: id_crop_operation 3 → product_type 'ferti'
 */
export function getProductTypeForOperation(id_crop_operation) {
  const id = parseInt(id_crop_operation)
  return PRODUCT_TYPES.find(t => t.id_crop_operation === id) || null
}

/**
 * Verifica se un tipo di operazione richiede la gestione prodotti
 */
export function operationNeedsProducts(id_crop_operation) {
  return !!getProductTypeForOperation(id_crop_operation)
}

/**
 * Calcola il residuo di un prodotto basandosi sulle operazioni.
 * Le operazioni hanno un array `products` con { id_product, amount_tot, uom }.
 * Tutti i valori vengono normalizzati in unità base (kg o l) prima di sottrarre,
 * poi il risultato viene riconvertito nell'uom del prodotto.
 */
export function calcResidual(product, operations) {
  if (!product || !operations) return product?.quantity || 0

  const stockMult = UOM_MULTIPLIER[product.uom] || 1
  const stockBase = (parseFloat(product.quantity) || 0) * stockMult

  let usedBase = 0
  for (const op of operations) {
    if (op.products && Array.isArray(op.products)) {
      for (const p of op.products) {
        if (p.id_product === product.id_product) {
          const mult = UOM_MULTIPLIER[p.uom] || 1
          usedBase += (parseFloat(p.amount_tot) || 0) * mult
        }
      }
    }
    // legacy: id_product diretto sull'operazione
    else if (op.id_product === product.id_product) {
      const mult = UOM_MULTIPLIER[op.uom] || 1
      usedBase += (parseFloat(op.amount_tot) || 0) * mult
    }
  }

  return (stockBase - usedBase) / stockMult
}
